<a class="content" [routerLink]="['/', 'blog', blog?.slug] | localize">
  <div class="content__img">
    <img
      *ngIf="blog?.seo"
      [src]="
        blog?.seo
          | seoImageUrl
            : {
                text: false,
                format: 'rectangle',
                logo: true,
                category: blog?.__typename
              }
      "
      [alt]="blog?.seo?.title"
      [title]="blog?.seo?.title"
    />
  </div>
  <div class="content__container">
    <div class="container">
      <p class="container__date">{{ blog?.publication }}</p>
      <h3 class="container__title">{{ blog?.seo?.title }}</h3>
      <p class="container__description">{{ blog?.seo?.description }}</p>
    </div>
  </div>
</a>
